export default __webpack_public_path__ + "static/media/logo-zad-02.2c254cd3.png";